export type StandardErrorType = {
  new (message: string, context?: any): StandardError;
};

export class StandardError extends Error {
  constructor(message: string, public code: string, public context?: any) {
    super(message);
  }
}
